// GENERATED by scripts/build/generate-mdr-catalog.ts. Do not edit by hand.
import auditComponents from '../../../modules/audit/presentation/components/registry.js';
import bookingCoreComponents from '../../../modules/booking_core/presentation/components/registry.js';
import catalogComponents from '../../../modules/catalog/presentation/components/registry.js';
import customerManagementComponents from '../../../modules/customer_management/presentation/components/registry.js';
import expenseComponents from '../../../modules/expense/presentation/components/registry.js';
import identityAccessComponents from '../../../modules/identity_access/presentation/components/registry.js';
import invoicingComponents from '../../../modules/invoicing/presentation/components/registry.js';
import menuComponents from '../../../modules/menu/presentation/components/registry.js';
import notificationsComponents from '../../../modules/notifications/presentation/components/registry.js';
import operationsReadModelComponents from '../../../modules/operations_read_model/presentation/components/registry.js';
import paymentProcessingComponents from '../../../modules/payment_processing/presentation/components/registry.js';
import playSessionComponents from '../../../modules/play_session/presentation/components/registry.js';
import posComponents from '../../../modules/pos/presentation/components/registry.js';
import publicPortalComponents from '../../../modules/public_portal/presentation/components/registry.js';
import resourceManagementComponents from '../../../modules/resource_management/presentation/components/registry.js';
import takeoutComponents from '../../../modules/takeout/presentation/components/registry.js';
import venueConfigurationComponents from '../../../modules/venue_configuration/presentation/components/registry.js';
import waitlistComponents from '../../../modules/waitlist/presentation/components/registry.js';

import { createUiComponentLoaderCatalog } from '../../mdr-react/src/index.js';

export const generatedUiComponentLoaders = createUiComponentLoaderCatalog([
  auditComponents,
  bookingCoreComponents,
  catalogComponents,
  customerManagementComponents,
  expenseComponents,
  identityAccessComponents,
  invoicingComponents,
  menuComponents,
  notificationsComponents,
  operationsReadModelComponents,
  paymentProcessingComponents,
  playSessionComponents,
  posComponents,
  publicPortalComponents,
  resourceManagementComponents,
  takeoutComponents,
  venueConfigurationComponents,
  waitlistComponents,
]);
